<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @del="del"
    >
      <Header
        slot="header"
        @addBatch="() => (orderBatchDialogVisible = true)"
        @batchDel="batchDel"
        :disabled="disabled"
      />
    </Main>

    <ChooseOrderBatchDialog
      :title="
        $l('INDEX.order_goods_label_orderGoods_information') || '订单批次信息'
      "
      :visible.sync="orderBatchDialogVisible"
      :changeOrderCode="changeOrderCode"
      type="checkbox"
      @confirm="orderBatchConfirm"
    />
  </div>
</template>
<script>
import Main from './main'
import Header from './header.vue'
import ChooseOrderBatchDialog from '../choose-order-batch/dialog.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main, Header, ChooseOrderBatchDialog },
  props: {
    orderInspectionCode: { type: String, default: '' },
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    isExpand: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      orderBatchDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderInspectionCode) return
      this.loading = true
      this.tableData = []
      this.$api
        .changeOrderInspectionBatchListApi({
          orderInspectionCode: this.orderInspectionCode,
          changeOrderCode: this.changeOrderCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    orderBatchConfirm(data) {
      if (this.isExpand) {
        this.addDBData(data)
        return
      }
      this.addTableData(data)
    },
    addTableData(data) {
      if (!data || !data.length) return
      const tableData = data
        .map((i) => {
          return {
            orderBatchCode: i.orderBatchCode,
            orderBatchNo: i.orderBatchNo,
            identifyNo: i.identifyNo,
            deliveryDate: i.deliveryDate,
            outBillType: i.outBillType,
            dispatchPort: i.dispatchPort,
            destinationPort: i.destinationPort,
          }
        })
        .filter(
          (i) =>
            this.tableData.findIndex((j) => j.orderBatchNo === i.orderBatchNo) <
            0
        )
      this.tableData.push(...tableData)
    },
    addDBData(data) {
      const listBatchCode = data
        .map((i) => i.orderBatchCode)
        .filter(
          (i) => this.tableData.findIndex((j) => j.orderBatchCode === i) < 0
        )

      if (listBatchCode.length !== data.length) {
        this.$message(
          this.$l('INDEX.inspection_choose_goods_repeat_tips') ||
            '已为您过滤掉重复的产品信息！'
        )
      }

      if (!listBatchCode || !listBatchCode.length) return
      const params = {
        changeOrderCode: this.changeOrderCode,
        orderInspectionCode: this.orderInspectionCode,
        listBatchCode,
      }
      this.loadingOpen()
      this.$api
        .changeOrderInspectionBatchSaveApi(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.getData()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    batchDel() {
      if (!this.tableData || !this.tableData.length) return
      const delRows = this.$refs.main.getCheckboxRecords()
      if (!delRows) return
      if (this.isExpand) {
        this.delDBData(delRows)
        return
      }
      this.delTableData(delRows)
    },
    delTableData(delRows) {
      const tableData = this.tableData.filter(
        (i) => delRows.findIndex((j) => i.orderBatchNo == j.orderBatchNo) < 0
      )
      this.tableData = [...tableData]
    },
    delDBData(delRows) {
      const listBatchCode = delRows.map((i) => i.changeOrderInspectionBatchCode)
      const dataCount = this.tableData.length || 0

      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .changeOrderInspectionBatchsDelApi({ listBatchCode })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(
                this.$l('INDEX.tips_delete_no') || '删除失败！'
              )
              return
            }
            this.$message({
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getData()
            if (listBatchCode.length >= dataCount) this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    del(orderBatchCode) {
      const delRow = this.tableData.filter(
        (i) => i.orderBatchCode === orderBatchCode
      )
      if (this.isExpand) {
        this.delDBData(delRow)
        return
      }
      this.delTableData(delRow)
    },
    getBatchCodes() {
      return this.tableData.map((i) => i.orderBatchCode)
    },
  },
}
</script>
